import React from 'react';

export const Logout: React.FC = () => {
  return <h3>Logged Out</h3>;
};
